module.exports = __webpack_public_path__ + "static/media/tom.86a9b637.jpg";